export default [
  {
    header: 'داشبورد',
    icon: 'HomeIcon',
    children: [
      {
        title: 'داشبورد',
        route: 'dashboard',
        icon: 'ShoppingCartIcon',
      },

    ],
  },
]
